<template>
  <s-modal
    v-model="showModal"
    :title="$t('module-information.confirm-title')"
    size="lg"
    :ok-title="$t('actions.continue')"
    @ok="openExternalLink"
    @cancel="closeModal"
  >
    <b-container fluid>
      <b-row>
        <p>
          {{$t('module-information.messages.MA001')}}
        </p>
      </b-row>
      <b-row>
        <p>
          <strong>{{ link }}</strong>
        </p>
      </b-row>
      <b-row>
        <p>
          {{$t('module-information.messages.MA002')}}
        </p>
      </b-row>
      <b-row>
        <p>
          {{$t('module-information.messages.MA003')}}
        </p>
      </b-row>
    </b-container>
  </s-modal>
</template>

<script>
export default {
  name: 'ModuleInformationConfirmModal',
  props: {
    value: {
      type: Boolean,
      required: true,
      default: false,
    },
    link: {
      type: String,
      required: true,
    },
  },
  computed: {
    showModal: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
  methods: {
    closeModal() {
      this.showModal = false;
      this.$emit('refresh');
    },
    openExternalLink() {
      this.showModal = false;
      window.open(this.link, '_blank');
    },
  },
};
</script>

<style lang="sass" scoped>
::v-deep .modal-header
  display: block

@page
  margin: 0 auto

  @media print
    .modal-dialog,
    .modal-content
      max-width: 100vw
      width: 100vw
      height: 100vh
      margin: 0 auto

    .modal-content
      position: absolute
      top: 0
      left: 0
      right: 0
      bottom: 0
</style>
